
import Hero from "../Components/Home/Hero";
import Services from "../Components/Home/Services";
import Overview from "../Components/Home/OverView";
import PastEvents from "../Components/Home/Pastevents";
const MainPage = () => {
  
  return (
    <div>
<Hero/>
<Services/>
<Overview/>
    <PastEvents />

    </div>
  );
};

export default MainPage;